import React from 'react';
import { Trans } from 'react-i18next';
import classes from './Header.module.scss';
import DrawerMenu from '../DrawerMenu/DrawerMenu';
import { useDispatch, useSelector } from 'react-redux';
import { setWidgetIsOpen } from '../../store/actions/general';
import MuiPlaceholder from '../controls/MuiPlaceholder/MuiPlaceholder';

const Header = ({socket}) => {
  const { muiFontLoaded } = useSelector(state => state.general);
  const dispatch = useDispatch();

  const minimizeWidget = () => {
    dispatch(setWidgetIsOpen(false));
  };

  // const closeWidget = () => {
  //   dispatch(setEndChatIsOpen(true))
  // };

  return (
    <div className={classes.Header} style={window.sutherland_variables.ui.header_styles.background}>
      <div className={classes.HeaderTitle}>
        {window.sutherland_variables.ui.header_image_url ? (
          <div className={classes.Image}>
            <div>
              <img
                src={window.sutherland_variables.ui.header_image_url}
                alt='Logo'
                style={{
                  height: window.sutherland_variables.ui.header_image_size,
                }}
              />
            </div>
            <div>
              <span style={window.sutherland_variables.ui.header_styles.title}>
                <Trans i18nKey="header.title">
                  {window.sutherland_variables.ui.header_title}
                </Trans>
              </span><br/>
              <Trans i18nKey="header.subTitle">
                <span className={classes.SubTitle} style={window.sutherland_variables.ui.header_styles.sub_title}>{window.sutherland_variables.ui.header_sub_title}</span>
              </Trans>
            </div>
          </div>
        ) : (
          <div>
            <Trans i18nKey="header.title">
              <span style={window.sutherland_variables.ui.header_styles.title}>{window.sutherland_variables.ui.header_title}</span>
            </Trans>
          </div>
        )}
        <div className={classes.HeaderButtons}>
          <DrawerMenu socket={socket}/>
            <button className={classes.IconButton} onClick={minimizeWidget} style={{color: window.sutherland_variables.ui.header_styles.icon_colors}}>
              <MuiPlaceholder
                isMuiFontLoaded={muiFontLoaded}
                element={<div>close</div>}
                width={30}
                height={30}
                backgroundColor={'#eeeeee'} />
            </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
